<template>
  <div class="contact-us">
    <!-- Header -->
    <vue-headful
      v-if="meta"
      :title="meta.fields['Title']"
      :description="meta.fields['Description']"
      :keywords="meta.fields['Keywords']" />
    <!-- End Header -->

    <!-- Loader -->
    <vue-element-loading
      :active="isGetProjectEnquiriesLoading"
      is-full-screen
      spinner="bar-fade-scale" />
    <!-- End Loader -->

    <!-- Submit Loader -->
    <vue-element-loading
      is-full-screen
      :active="isSubmitLoading"
      spinner="ring" />
    <!-- End Submit Loader -->

    <!-- Successful Modal -->
    <v-container>
      <v-dialog
        v-model="isSubmitSucceed"
        persistent
        max-width="300">
        <v-card>
          <v-card-title class="headline">
            Enquiry Sent
          </v-card-title>
          <v-card-text>Thank you for your enquiry. We will get back to you as soon as possible.</v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green darken-1"
                   text
                   @click="isSubmitSucceed = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <!-- End Successful Modal -->

    <v-container
      v-if="!isGetProjectEnquiriesLoading"
      style="max-width: 1000px;">
      <section
        id="project-enquiry"
        style="max-width: 500px;"
        class="mx-3">
        <h1 class="display-3 font-weight-black mb-2">
          Project Enquiry
        </h1>
        <p class="subtitle-1">
          Do you have a project you need to build? Complete a really short form and share it with us, then let us explore how we may build together!
        </p>
        <v-container
          v-if="projectEnquiries"
          class="my-10">
          <div class="caption">
            {{ `Question ${currentQuestion} of ${totalQuestions}` }}
          </div>
          <div
            v-for="enquiry in projectEnquiries"
            :id="enquiry.id"
            :key="enquiry.id">
            <div v-if="currentQuestion === enquiry.fields.Order">
              <question-template :question="enquiry.fields.Question"
                                 :answers="enquiry.fields.Answer"
                                 :type="enquiry.fields.Type"
                                 :order="enquiry.fields.Order"
                                 :prevselected="selected"
                                 :placeholder="enquiry.fields.Placeholder"
                                 @save-enquiry="handleSaveEnquiry" />
            </div>
          </div>
          <v-row justify="space-between">
            <v-btn
              color="grey lighten-2"
              class="px-10 mr-2 flex-grow-1"
              style="border-radius: 8px;"
              @click="onClickBack()">
              <v-icon>
                arrow_left
              </v-icon>
              Back
            </v-btn>
            <v-btn
              v-if="currentQuestion!==totalQuestions "
              :disabled="isNotAllowToProceed"
              color="black"
              class="white--text px-10 ml-2 flex-grow-1"
              style="border-radius: 8px;"
              @click="onClickNext()">
              Next
              <v-icon>
                arrow_right
              </v-icon>
            </v-btn>
            <v-btn
              v-if="currentQuestion===totalQuestions"
              :disabled="selected.length !== totalQuestions || isNotAllowToProceed"
              class="blue white--text px-10 ml-2 flex-grow-1"
              style="border-radius: 8px"
              @click="onSubmit()">
              Submit
            </v-btn>
          </v-row>
        </v-container>
      </section>

      <!-- Find Us -->
      <section
        id="address">
        <h1 class="display-1 font-weight-black my-5 mx-3">
          Find Us!
        </h1>
        <p class=" mx-3">
          100D Pasir Panjang Road<br>
          #02-09 Meissa<br>
          Singapore 118520<br><br>
          +65 63233 531
        </p>
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15955.313718825211!2d103.795743!3d1.276332!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xd90c50c5d71f651a!2sPixelsquad%20Pte.%20Ltd.!5e0!3m2!1sen!2ssg!4v1579488630419!5m2!1sen!2ssg"
                height="450"
                frameborder="0"
                style="border:0; width: 100%;"
                allowfullscreen="" />
      </section>
      <!-- End Find Us -->
    </v-container>
  </div>
</template>
<script>
import VueElementLoading from 'vue-element-loading';
import axios from "axios";
import _ from "lodash";
import qs from "qs";
import QuestionTemplate from '../components/forms/QuestionTemplate';

export default {
	name: "Contact",

	components: {
		VueElementLoading,
		QuestionTemplate
	},

	data() {
		return {
			apiUrl: this.$VUE_APP_AIRTABLE_URL,
			apiKey: this.$VUE_APP_AIRTABLE_API_KEY, // Always use a read-only account token
			apiBase: this.$VUE_APP_AIRTABLE_BASE,
			apiContactBase: this.$VUE_APP_AIRTABLE_CONTACT_BASE, // Always use a write-only account-token

			isGetProjectEnquiriesLoading: false,
			isSubmitLoading: false,
			isSubmitSucceed: false,

			projectEnquiries: [], // Airtable array of questions

			currentQuestion: 1, // Current question on page load
			totalQuestions: 0, // Total number of questions

			selected: [],
		};
	},

	mounted: function() {
		this.isGetProjectEnquiriesLoading= true;
		this.getProjectEnquiries();
	},

	computed: {
		meta: function () {
			return this.$store.getters['meta/getMeta'](this.$route.path);
		},

		isNotAllowToProceed: function() {
			for (let i = 0; i < this.selected.length; i++) {
				const select = this.selected[i];
				if (select['Order'] === this.currentQuestion && select['Valid'] === true && !(select['Answer'] === undefined || select['Answer'].length === 0 || select['Answer'] === '')) {
					return false;
				}
			}
			return true;
		},
	},

	methods: {

		onClickBack: function() {
			if (this.currentQuestion > 1) this.currentQuestion = this.currentQuestion - 1;
		},

		onClickNext: function() {
			if (this.currentQuestion < this.totalQuestions) this.currentQuestion = this.currentQuestion + 1;			},

		onSubmit: function() {
			this.postProjectEnquiry();
		},

		handleSaveEnquiry: function(value) {
			const foundIndex = this.selected.findIndex(el => el['Order'] === value['Order']);

			// Remove element from array if 'Answer' has no value
			// if (value['Answer'] === undefined || value['Answer'].length == 0 || value['Answer'] === '') {
			// 	this.selected.splice(foundIndex, 1);

			// } else {
			// Insert new element or update an existing element
			this.selected.splice(foundIndex, foundIndex === -1 ? 0 : 1, value);
			// }
		},

		getProjectEnquiries: function() {
			axios({
				url: this.apiUrl + this.apiBase + "/ProjectEnquiry",
				headers: {
					Authorization: `Bearer ${this.apiKey}`
				},
				params: {
					sort: [ { field: "Order", direction: "asc" } ]
				},
				paramsSerializer: function(params) {
					return qs.stringify(params);
				}
			}).then(res => {
				this.projectEnquiries = Array.from(res.data.records);

				// Check how many questions are there.
				let prevTotalQuestions = this.totalQuestions;
				for (let i = 0; i < this.projectEnquiries.length; i++) {
					if (this.projectEnquiries[i].fields.Order > prevTotalQuestions) {
						prevTotalQuestions = this.projectEnquiries[i].fields.Order;
					}
				}
				this.totalQuestions = prevTotalQuestions;
			}).finally(() => {
				this.isGetProjectEnquiriesLoading = false;
			});
		},

		postProjectEnquiry: function() {
			this.isSubmitLoading = true;

			// Sort by 'Order'
			const sortedSelected = this.selected.sort((a, b) => {
				return a['Order'] - b['Order'];
			});

			const email = this.selected.find(el => el['Type'] === 'email');
			const name = this.selected.find(el => el['Type'] === 'text');
			const tel = this.selected.find(el => el['Type'] === 'tel');

			// HTML email template
			let bodyText = '';
			sortedSelected.forEach(el => {
				bodyText = bodyText + `<div><bold>${el['Order']}. ${el['Question']}</bold><p>${el['Answer']}</p></div>`;
			});

			const data = {
				"fields": {
					"Email": email['Answer'][0],
					"Name": name['Answer'][0],
					"Tel": tel['Answer'][0],
					"Body Text": bodyText,
				}
			};

			axios({
				method: 'POST',
				url: this.apiUrl + this.apiContactBase + "/Enquiries",
				data,
				headers: {
					Authorization: `Bearer ${this.apiKey}`,
					'Content-Type': 'application/json'
				},
				paramsSerializer: function(params) {
					return qs.stringify(params);
				}
			}).then(res => {
				if (res.status === 200) {
					this.isSubmitSucceed  = true;
				} else {
					this.isSubmitError  = true;
				}
			}).catch(err => {
				// console.log(err);
			}).finally(() => {
				this.isSubmitLoading = false;

				setTimeout(() => {
					this.isSubmitSucceed = false;
					this.isSubmitError  = false;
				}, 5000);
			});
		}
	}
};
</script>
